import { render } from "./DateTimePicker.vue?vue&type=template&id=90efdc8c"
import script from "./DateTimePicker.vue?vue&type=script&lang=js"
export * from "./DateTimePicker.vue?vue&type=script&lang=js"
script.render = render

export default script